export default "__VITE_ASSET__BhUx3Nrb__"